<template>
  <div>
    <DrupalLink :to="article.url?.path" class="teaser-article-image">
      <MediaImage
        v-bind="article.titleImage"
        img-class="w-full"
        :image-style="imageStyle"
      />
    </DrupalLink>
    <Text
      class="mt-16 text-[12px] font-light uppercase text-grey-dark-02 md:mt-24"
    >
      {{ overline }}
    </Text>
    <DrupalLink
      :to="article.url?.path"
      class="teaser-article-title mt-8 inline-block w-full text-lg font-light uppercase hover:underline focus:underline md:mt-16"
      :class="{
        '!font-bold': isRebranding,
      }"
    >
      <Text>
        {{ article.title }}
      </Text>
    </DrupalLink>
    <div
      class="rich-text mt-6 text-base font-light text-grey-dark-01 md:block"
      :class="{
        hidden: !main,
        'text-lg leading-[32px]': main,
      }"
      v-html="article.teaserText"
    />
    <ButtonsLinkButton
      v-if="main"
      class="link-button mt-28 mobile-only:mb-40"
      :url="article.url?.path"
    >
      {{ $texts('readMore', 'Read more') }}
    </ButtonsLinkButton>
  </div>
</template>

<script setup lang="ts">
import type { DefineImageStyleConfig } from '#rokka/types'
import type { MagazineArticleTeaserFragment } from '#graphql-operations'

import { falsy } from '~/helpers/type'

const props = defineProps<{
  article: MagazineArticleTeaserFragment
  imageStyle: DefineImageStyleConfig
  main?: boolean
}>()

const { $texts } = useEasyTexts()
const isRebranding = await useFeatureFlag()

const overline = computed(() =>
  props.article.categories
    ?.map((v) => v.label)
    .filter(falsy)
    .join(', '),
)

defineOptions({
  name: 'MagazineHighlightGridTeaser',
})
</script>

<style lang="postcss" scoped>
.teaser-article-image:hover ~ .teaser-article-title {
  @apply underline;
}
</style>
